import { Injectable } from '@angular/core';
import { QPStore } from 'qp-store';
import { getAppVersion, getBuildVersion, getDeviceManufacturer, getDeviceModel, getPlatformName } from 'qp-utility';
import { DeviceHandlerService } from 'src/app/shared/services/device-handler/device-handler.service';
import { FireboltService } from 'src/app/shared/services/firebolt.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StoreService extends QPStore {
  constructor(private readonly deviceHandler: DeviceHandlerService, private readonly fireboltService: FireboltService) {
    super();
    this.init();
  }

  /**
   * init SDK
   * Set base event data in store
   *  - DeviceInfo
   *  - AsnInfo
   *  - RegionInfo (rule service)
   *  - AppInfo
   *  - UserAgentInfo
   *  - session (session service)
   *  - EventInfo
   *  - UserRegionInfo
   */
  async init(): Promise<void> {
    const newTxt = navigator.userAgent.split('(');
    const userAgentData = [];
    for (let i = 1; i < newTxt.length; i++) {
      userAgentData.push(newTxt[i].split(')')[0]);
    }
    const devMod = await this.fireboltService.getDeviceName();
    const devMan = await this.fireboltService.getDeviceManufacturer();
    const devPlat = await this.fireboltService.getDevicePlatform();

    this.setDeviceInfo({
      device: devMod || userAgentData[0],
      deviceID: this.deviceHandler.getCurrentDeviceID(),
      deviceGroup: 'TV',
      deviceManufacturer: devMan || getDeviceManufacturer(),
      deviceModel: devMod || getDeviceModel(),
      deviceType: 'TV',
      platformName: devPlat || getPlatformName(),
    });
    this.setBrowserInfo(this.deviceHandler.getUserAgentDetails());
    this.setAsnInfo({
      asn: environment.app.asn,
      asnOwner: environment.app.asnowner,
    });
    this.setAppInfo({
      appName: 'Univision Now Comcast - TVE',
      appVersion: getAppVersion(),
      appBuild: getBuildVersion(),
    });
  }
}
